export default __webpack_public_path__ + "static/media/generating.6a702929.gif";